import { User, RequestResult } from "domain/entities/user";
import { UserRepository } from "domain/repositories";

export default class CreateUseCase {
    private userRepository: UserRepository;
    
    public constructor(userRepository: UserRepository) {
        this.userRepository = userRepository
    }

    public async createUser(user: User, token: Promise<[string | null, string | null]>): Promise<([RequestResult, null]) | ([null, Error])> {
        const [t, ] = await token;
        if (t !== null) {
            return this.userRepository.createUser(user, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}